// src/api/user.service.js
import API from './axiosConfig';

export const signup = async (userData) => {
  const response = await API.post('/login/create-user', userData);
  return response.data;
};

export const getRoles = async () => {
  const response = await API.get('/login/getroles');
  return response.data;
};

export const getDepartments = async () => {
  const response = await API.get('/login/getDepartment');
  return response.data;
};

export const getAllUsers = async () => {
  const response = await API.get('/users');
  return response.data;
};